import styled from 'styled-components';

export const MenuStyles = styled.div`
  width: 100vw;
  height: 100vh;

  background: #1B1F2C;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
  padding: 16px;
  box-sizing: border-box;
  overflow-y: auto;
  
  transform: translateY(-100%);
  transition: 0.4s ease all;
  
  &.active {
    transform: translateY(0);
  }
  
  .closeMenuButton {
    position: absolute;
    right: 16px;
    top: 4px;
    width: 36px;
    height: 36px;

    @media (max-width: 600px) {
      font-size: 24px;
      line-height: 24px;
    }

    &::before, &::after {
      position: absolute;
      content: ' ';
      height: 36px;
      width: 3px;
      background-color: #FFF;

      @media (max-width: 600px) {
        height: 24px;
        width: 2px;
      }
    }
    &::before {
      transform: rotate(45deg);
    }
    &::after {
      transform: rotate(-45deg);
    }
  }
  
  ul {
    display: grid;
    gap: 16px;
    
    font-weight: 700;
    font-size: 30px;
    line-height: 130%;
    /* identical to box height, or 144% */
    color: #FFFFFF;
    
    @media (max-width: 600px) {
      font-size: 18px;
      line-height: 26px;
    }
    
    li:hover {
      a {
        color: #FFC228;
        transition: 0.3s ease all;
      }
    }
  }
`;
